/**
 * Updates form data with new value
 * @param {Object} currentData - Current form data
 * @param {string} name - Field name
 * @param {*} value - New value
 * @returns {Object} Updated form data
 */
export const updateFormData = (currentData, name, value) => ({
  ...currentData,
  [name]: value
});

/**
 * Handles service section management
 * @param {Array} currentSections - Current service sections
 * @returns {Object} Service section management functions
 */
export const useServiceSections = (currentSections) => {
  const addSection = () => [...currentSections, currentSections.length];
  
  const deleteSection = (index) => {
    if (currentSections.length > 1) {
      return currentSections.filter(i => i !== index);
    }
    return currentSections;
  };

  return { addSection, deleteSection };
};

/**
 * Resets filter data to initial state
 * @returns {Object} Initial filter state
 */
export const getInitialFilterState = () => ({
  dateFrom: '',
  dateTo: '',
  assignee: '',
  stage: '',
  sector: '',
  source: ''
}); 